import { useCallback } from 'react'

import { ToastT } from 'sonner'

import { useHandleInsufficientNativeTokenError } from '~/hooks/transactions/useHandleInsufficientNativeTokenError'
import { useNavigation } from '~/hooks/useNavigation'
import { getSplitsErrorCodeString } from '~/hooks/useRequests'
import { useOrgRootSmartAccount } from '~/hooks/useSmartAccounts'
import { Address } from '~/utils/address'

export const useHandleMerkleTransactionError = () => {
  const handleInsufficientNativeTokenError =
    useHandleInsufficientNativeTokenError()
  const navigate = useNavigation()
  const { smartAccount: { address: rootAccountAddress } = {} } =
    useOrgRootSmartAccount()

  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (error: any): Omit<ToastT, 'id'> | undefined => {
      if (
        getSplitsErrorCodeString(error) ===
        'SMART_ACCOUNT_MERKLE_TRANSACTION_IN_PROGRESS'
      ) {
        const blockingAccountAddress =
          error.response?.data?.data?.smartAccountAddress
        const path =
          rootAccountAddress &&
          blockingAccountAddress &&
          Address.equal(rootAccountAddress, blockingAccountAddress)
            ? `/accounts/${blockingAccountAddress}/`
            : '/'

        return {
          duration: 10000,
          action: {
            label: 'View transactions',
            onClick: () => navigate(path),
          },
        }
      }

      return handleInsufficientNativeTokenError(error)
    },
    [handleInsufficientNativeTokenError, navigate, rootAccountAddress],
  )
}
